import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .content': {
        position: 'relative'
    },
    '& ul,& li': {
        padding: 0,
        margin: 0,
        listStyle: 'none'
    },
    '& .select': {
        minWidth: '100px',
        marginTop: '0',
        marginBottom: '0'
    },
    '& .h': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    '& .flow': {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'flex-start'
    },
    '& .ht': {
        alignItems: 'flex-start'
    },
    '& .hr': {
        justifyContent: 'flex-end'
    },
    '& .c': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    '& .title': {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#212C31'
    },
    '& .subtitle': {
        fontSize: '14px',
        color: '#005F9B'
    },
    '& .menu': {
        marginTop: '27px',
        marginBottom: '30px'
    },
    '& .menu .menu-item': {
        width: '140px',
        height: '140px',
        backgroundColor: '#ffffff',
        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
        borderRadius: '13px',
        fontSize: '14px',
        marginRight: '24px',
        textAlign: 'center',
        minWidth: '88px',
        cursor: 'pointer',
        lineHeight: '1.4em',
        transition: 'transform 0.2s'
    },
    '& .menu .menu-item:hover': {
        fontWeight: 'bold',
        color: '#005E96',
        transform: 'scale(1.1)',
    },
    '& .menu .menu-item img': {
        width: '60px',
        height: '70px',
        marginBottom: '16px'
    },
    '& .panel': {
        backgroundColor: '#ffffff',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.2)',
        borderRadius: '6px',
        height: '100%',
    },
    '& .panel .panel-title': {
        height: '48px',
        backgroundColor: '#7BC3E8',
        color: '#ffffff',
        padding: '0 18px',
        fontSize: '0.875rem',
        fontWeight: 'bold',
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px'
    },
    '& .panel-content': {
        position: 'relative',
        padding: '18px 25px'
    },
    '& .panel-1 .panel-content': {
        paddingBottom: '50px'
    },
    '& .panel-2 .panel-content': {
        minHeight: '306px'
    },
    '& .panel-3 .panel-content': {
        minHeight: '306px'
    },
    '& .panel-4 .panel-content': {
        minHeight: '346px'
    },
    '& .panel-5 .panel-content': {
        minHeight: '346px'
    },
    '& .panel-6 .panel-content': {
        minHeight: '346px'
    },
    '& .panel-1 .row': {
        marginTop: '20px',
        fontSize: '14px',
        color: '#9B9B9B'
    },
    '& .panel-1 .row1': {
        marginTop: '30px'
    },
    '& .panel-1 img': {
        width: '32px',
        height: '34px',
        marginRight: '20px'
    },
    '& .panel-1 .col': {
        borderBottom: '1px solid #009CEE',
        paddingBottom: '13px'
    },
    '& .panel-1 .col-gap': {
        width: '36px'
    },
    '& .panel-1 .col-value': {
        fontSize: '28px',
        color: '#212C31'
    },

    '& .panel .more': {
        position: 'absolute',
        bottom: '11px',
        right: '25px',
        color: '#009CEE',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    '& .thead': {
        whiteSpace: 'nowrap'
    },
    '& .invoice-chart': {
        width: '100%',
        height: '239px'
    },
    '& .timesheet-chart': {
        width: '100%',
        height: '239px'
    },
    '& .referral-chart': {
        width: '100%',
        height: '239px'
    },

    '& .member': {
        padding: '0 40px',
        fontSize: '16px',
        paddingBottom: '27px',
        paddingTop: '9px'
    },
    '& .member .m-img': {
        width: '104px',
        height: '104px',
        borderRadius: '52px',
        marginBottom: '24px'
    },
    '& .member .m-name': {
        color: '#005F9B'
    },
    '& .line': {
        width: '2px',
        height: '50px',
        backgroundColor: '#DADADA'
    }

});